export interface CampaignDistributionRow {
  name: string;
  value: number;
  color?: string;
}

const DEFAULT_OTHER_COLOR = '#94a3b8';

export function truncateChartLabel(value: string, maxLength = 18): string {
  if (!value) return '';
  return value.length > maxLength ? `${value.slice(0, maxLength - 1)}…` : value;
}

/** Collapse long campaign lists into top N + "Other campaigns" for readable bar charts. */
export function prepareCampaignChartData(
  campaigns: CampaignDistributionRow[],
  topN = 10,
): CampaignDistributionRow[] {
  const sorted = [...campaigns]
    .filter((row) => row.value > 0)
    .sort((a, b) => b.value - a.value || a.name.localeCompare(b.name));

  if (sorted.length <= topN) {
    return sorted;
  }

  const top = sorted.slice(0, topN);
  const otherValue = sorted.slice(topN).reduce((sum, row) => sum + row.value, 0);

  if (otherValue <= 0) {
    return top;
  }

  return [
    ...top,
    {
      name: 'Other campaigns',
      value: otherValue,
      color: DEFAULT_OTHER_COLOR,
    },
  ];
}

export function campaignChartHeight(rowCount: number): number {
  return Math.min(520, Math.max(280, rowCount * 34 + 40));
}

export function departmentChartHeight(rowCount: number): number {
  return Math.max(280, rowCount * 48 + 80);
}
